type SchemeDisplaySource = {
  alternateName?: string | null;
  schemeName?: string | null;
  schemeMetaDataName?: string | null;
};

export const getSchemeDisplayName = (
  source?: SchemeDisplaySource | null,
  fallback = "-"
) =>
  source?.alternateName ||
  source?.schemeName ||
  source?.schemeMetaDataName ||
  fallback;
